(function(){
  'use strict';
  var mobile=window.matchMedia('(max-width: 767px)');
  var reduceMotion=window.matchMedia('(prefers-reduced-motion: reduce)');
  var hintPrepared=false;
  var hintTimer=0;
  var proximityObserver=null;

  function loadImage(gallery,index){
    var image=gallery.querySelector('[data-rit-slide="'+index+'"] img');
    if(!image||image.getAttribute('src'))return;
    image.srcset=image.getAttribute('data-rit-srcset')||'';
    image.src=image.getAttribute('data-rit-src')||'';
  }

  function update(gallery){
    var viewport=gallery.querySelector('.rit-mobile-gallery__viewport');
    if(!viewport||!viewport.clientWidth)return;
    var index=Math.max(0,Math.min(gallery.querySelectorAll('[data-rit-slide]').length-1,Math.round(viewport.scrollLeft/viewport.clientWidth)));
    gallery.querySelectorAll('.rit-mobile-gallery__progress span').forEach(function(line,lineIndex){line.classList.toggle('is-active',lineIndex===index);});
    loadImage(gallery,index);
    if(index>0)loadImage(gallery,index+1);
  }

  function prepareHint(gallery){
    if(hintPrepared||reduceMotion.matches)return;
    hintPrepared=true;
    var observer=new IntersectionObserver(function(entries){
      if(!entries.some(function(entry){return entry.isIntersecting&&entry.intersectionRatio>=.45;}))return;
      observer.disconnect();
      loadImage(gallery,1);
      var scheduleHint=function(){
        if(gallery.getAttribute('data-rit-user-interacted')==='true')return;
        hintTimer=window.setTimeout(function(){
          hintTimer=0;
          if(reduceMotion.matches||gallery.getAttribute('data-rit-user-interacted')==='true')return;
          gallery.classList.add('rit-hinting');
          gallery.addEventListener('animationend',function(){gallery.classList.remove('rit-hinting');},{once:true});
        },1000);
      };
      if(document.readyState==='complete')scheduleHint();
      else window.addEventListener('load',scheduleHint,{once:true});
    },{threshold:[.45]});
    observer.observe(gallery);
  }

  function observeProximity(gallery){
    if(proximityObserver)proximityObserver.observe(gallery);
  }

  function startProximityPreload(){
    if(!mobile.matches||proximityObserver)return;
    proximityObserver=new IntersectionObserver(function(entries){
      entries.forEach(function(entry){
        if(!entry.isIntersecting)return;
        proximityObserver.unobserve(entry.target);
        loadImage(entry.target,1);
      });
    },{rootMargin:'160px 0px',threshold:0});
    document.querySelectorAll('[data-rit-mobile-gallery][data-rit-gallery-ready="true"]').forEach(observeProximity);
  }

  function init(gallery){
    if(!mobile.matches||gallery.getAttribute('data-rit-gallery-ready')==='true')return;
    gallery.setAttribute('data-rit-gallery-ready','true');
    var productImage=gallery.closest('.product-image');
    var viewport=gallery.querySelector('.rit-mobile-gallery__viewport');
    if(!productImage||!viewport)return;
    productImage.classList.add('rit-has-mobile-gallery');
    productImage.querySelectorAll(':scope>.hover_img .back-img').forEach(function(image){
      image.classList.remove('lazyloadt4s','nt_bg_lz');
      image.removeAttribute('data-bgset');
    });
    loadImage(gallery,0);
    var startX=0,moved=false,scrollFrame=0;
    viewport.addEventListener('touchstart',function(event){
      gallery.setAttribute('data-rit-user-interacted','true');
      if(hintTimer){window.clearTimeout(hintTimer);hintTimer=0;}
      gallery.classList.remove('rit-hinting');startX=event.touches[0].clientX;moved=false;loadImage(gallery,1);
    },{passive:true});
    viewport.addEventListener('touchmove',function(event){
      if(Math.abs(event.touches[0].clientX-startX)>8)moved=true;
    },{passive:true});
    viewport.addEventListener('touchend',function(){if(moved)setTimeout(function(){moved=false;},500);},{passive:true});
    viewport.addEventListener('click',function(event){if(moved){event.preventDefault();event.stopPropagation();moved=false;}},true);
    viewport.addEventListener('scroll',function(){
      if(scrollFrame)return;
      scrollFrame=requestAnimationFrame(function(){scrollFrame=0;update(gallery);});
    },{passive:true});
    prepareHint(gallery);
    observeProximity(gallery);
  }

  function initAll(root){
    if(!mobile.matches)return;
    if(root.matches&&root.matches('[data-rit-mobile-gallery]'))init(root);
    if(root.querySelectorAll)root.querySelectorAll('[data-rit-mobile-gallery]').forEach(init);
  }

  function start(){
    initAll(document);
    new MutationObserver(function(records){records.forEach(function(record){record.addedNodes.forEach(initAll);});}).observe(document.documentElement,{childList:true,subtree:true});
    if(mobile.addEventListener)mobile.addEventListener('change',function(){initAll(document);startProximityPreload();});
    if(document.readyState==='complete')startProximityPreload();
    else window.addEventListener('load',startProximityPreload,{once:true});
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start);else start();
})();
